module.exports = __webpack_public_path__ + "b4c6577f7dc30755665730682a823206.ttf";